import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=fa8f294a&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=fa8f294a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8f294a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa8f294a')) {
      api.createRecord('fa8f294a', component.options)
    } else {
      api.reload('fa8f294a', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=fa8f294a&scoped=true&", function () {
      api.rerender('fa8f294a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2o2TaOdLCZXTj/JS/comp/Voucher.vue"
export default component.exports